// extracted by mini-css-extract-plugin
export default {"root":"styles_root__Qb+hg","title":"styles_title__O9BBg","creating":"styles_creating__6jQa4"};